import { Site } from './Site';
export interface Class {
  id: string;
  name: string;
  sectionName?: string;
  section?: string;
  site?: Site;
  gradeLevels?: Site[];
  isActive?: boolean;
  grades?: string;
  users?: ClassUser[];
  owner?: {
    id: string;
    firstName?: string;
    lastName?: string;
  };
  students?: {
    id?: string;
    assessments?: {
      skill?: {
        name?: string;
        code?: string;
        targetSkills?: {
          targetSkillType?: {
            name?: string;
          }[];
        };
      };
      score?: number;
    }[];
  };
  ownerName?: string;
  externalSync?: ExternalSync;
}
export interface ExternalSync {
  id?: string;
  externalId?: string;
  source?: string;
  sourceDataType?: string;
}

export interface ClassUser {
  id: string;
  firstName: string;
  lastName: string;
  email?: string;
  publicUserId: string;
  externalSync?: ExternalSync;
  userClasses?: {
    isActive: boolean;
    class: {
      id: string;
      name: string;
      section?: string;
    };
  }[];
  roles: {
    name: string;
  }[];
  sites: Site[];
  classes: {
    name: string;
    section?: string;
  }[];
  gradeLevels?: Site[];
  isActive?: boolean;
  studentTargetGroups?: {
    id: string;
    isCurrent: boolean;
    targetGroup?: { id: string; name: string };
  }[];
}

export interface ClassNameSection {
  id: string;
  name: string | null | undefined;
  section: string | null | undefined;
}

export const externalSyncMessage =
  'This class is managed by Clever Sync. Any changes in Clever will be updated each night into Roadmaps.';
